import styled from "styled-components";
import { Breadcrumb } from "react-bootstrap";
import UserOrders from "./userOrders";

const Container = styled.div`
  background-color: rgb(227, 242, 253);
  height: 100vh;
`;

const Content = styled.div`
  height: calc(100vh - 67.25px);
  padding: 1rem 1rem 1rem 1rem;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 5px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
`;

const UserOrderPage = () => {
  return (
    <Container className="card-theme">
      <Content className="d-flex flex-row w-100">
        <Card className="w-100 text-black bg-light">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active={true} href="/my-orders">
              My Orders
            </Breadcrumb.Item>
          </Breadcrumb>
          <UserOrders isMyOrders={true} />
        </Card>
      </Content>
    </Container>
  );
};

export default UserOrderPage;
